
import get    from 'dom/get.js';
import events from 'dom/events.js';
import select from 'dom/select.js';

const targets = select('.type-here-target', document);
const source = get('type-here');

if (source && targets) {
    targets.forEach(function(node) {
        node.setAttribute('data-orginal-html', node.innerHTML);
    });

    function setHTML(value, node) {
        node.innerHTML = value || node.getAttribute('data-orginal-html');
        return value;
    }
    events('input', source).each(function(e) {
        targets.reduce(setHTML, e.target.value);
    });
}
